











































import { IProfileCustomerUpdateData } from '@/common/interfaces/my-profile.interface';
import Vue from 'vue';
import TextInput from '../inputs/TextInput.vue';

interface IProfileCompanyDataFormComponent {
  companyUpdateData: IProfileCustomerUpdateData | null;
}

export default Vue.extend({
  components: {
    TextInput,
  },
  data(): IProfileCompanyDataFormComponent {
    return {
      companyUpdateData: null,
    };
  },
  props: {
    companyData: {
      default: () => { return {}; },
      type: Object as () => unknown,
    },
    isExternalRegistration: {
      default: false,
      type: Boolean,
    },
    isPartner: {
      default: false,
      type: Boolean,
    },
    isPartnerView: {
      default: false,
      type: Boolean,
    },
    isSelfRegistration: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    valueChanged(): void {
      this.$emit(`change`, JSON.parse(JSON.stringify(this.companyUpdateData)));
    },
  },
  watch: {
    companyData: {
      deep: true,
      handler(): void {
        this.companyUpdateData = JSON.parse(JSON.stringify(this.companyData));
      },
      immediate: true,
    },
  },
});
